export interface CoreValue {
  title: string;
  description: string;
  icon: string;
}

export const aboutValues: CoreValue[] = [
  {
    title: 'Integrity',
    description: 'We conduct every engagement with honesty and transparency, earning trust that lasts across generations.',
    icon: 'ri-hand-heart-line',
  },
  {
    title: 'Technical Excellence',
    description: 'Certified engineers and rigorous standards ensure every solution performs exactly as promised.',
    icon: 'ri-award-line',
  },
  {
    title: 'Reliability',
    description: 'From installation to after-sales support, clients count on us to be there when it matters most.',
    icon: 'ri-shield-check-line',
  },
  {
    title: 'Safety First',
    description: 'The wellbeing of people and property guides every decision, on every project, without compromise.',
    icon: 'ri-fire-line',
  },
];

export interface Pillar {
  title: string;
  description: string;
  icon: string;
}

export const aboutPillars: Pillar[] = [
  {
    title: 'Our Mission',
    description: 'To power progress across Nigeria by delivering dependable, safe and technically excellent power, fire safety and engineering solutions.',
    icon: 'ri-compass-3-line',
  },
  {
    title: 'Our Vision',
    description: 'To remain Nigeria\u2019s most trusted industrial solutions group, setting the benchmark for quality and long-term partnership.',
    icon: 'ri-eye-line',
  },
  {
    title: 'Our Promise',
    description: 'Real expertise, measurable reliability and genuine care for every client we serve \u2014 project after project.',
    icon: 'ri-shake-hands-line',
  },
];

export interface Milestone {
  year: string;
  title: string;
  description: string;
}

export const aboutMilestones: Milestone[] = [
  {
    year: '1861',
    title: 'A Trading Legacy Begins',
    description: 'The John Holt name is established in international trade, laying the foundation of a business built on trust.',
  },
  {
    year: '1900s',
    title: 'Rooted in West Africa',
    description: 'A strong presence is built across West Africa, with distribution and trading networks spanning the region.',
  },
  {
    year: '1961',
    title: 'Incorporated in Nigeria',
    description: 'John Holt PLC takes firm root in Nigeria, growing alongside the nation through its formative years.',
  },
  {
    year: '1990s',
    title: 'Into Engineering & Power',
    description: 'The group expands into power generation, engineering and technical services for industry and institutions.',
  },
  {
    year: '2010s',
    title: 'Nationwide Service Network',
    description: 'Dedicated sales, installation and after-sales support reach businesses across multiple states.',
  },
  {
    year: 'Today',
    title: 'Powering Modern Nigeria',
    description: 'A diversified group delivering integrated power, fire safety, engineering and distribution solutions.',
  },
];

export interface Leader {
  name: string;
  role: string;
  image: string;
}

export const aboutLeadership: Leader[] = [
  {
    name: 'Adewale Bankole',
    role: 'Group Managing Director',
    image: `${import.meta.env.BASE_URL}images/fdca4f544dbb8acf.jpg`,
  },
  {
    name: 'Ngozi Eze',
    role: 'Executive Director, Operations',
    image: `${import.meta.env.BASE_URL}images/fdca4f544dbb8acf.jpg`,
  },
  {
    name: 'Ibrahim Sule',
    role: 'Head of Engineering',
    image: `${import.meta.env.BASE_URL}images/fdca4f544dbb8acf.jpg`,
  },
  {
    name: 'Folake Adeyemi',
    role: 'Head of Fire Safety & Compliance',
    image: `${import.meta.env.BASE_URL}images/fdca4f544dbb8acf.jpg`,
  },
];

export interface Credential {
  label: string;
  icon: string;
}

export const aboutCredentials: Credential[] = [
  { label: 'Certified Engineering Teams', icon: 'ri-award-line' },
  { label: 'Nationwide Service Coverage', icon: 'ri-map-pin-2-line' },
  { label: 'Genuine Equipment & Brands', icon: 'ri-verified-badge-line' },
  { label: '24/7 Maintenance Support', icon: 'ri-customer-service-2-line' },
];